import React from 'react';
import { Routes, Route } from 'react-router-dom';
import { AuthGuard } from '../../components/AuthGuard';
import DataPortalLayout from '../../layouts/DataPortalLayout';
import EmbedPage from './embed/EmbedPage';
import DataPortalManagePage from './manage/DataPortalManagePage';

/**
 * 专题分析模块路由。
 *
 * `manage` 必须写在 `:pageKey` 之前——虽然 React Router v6 会让静态段优先于动态段，
 * 但显式排在前面更不容易被后人改坏。`pageKey` 由后端生成 8 位随机串，不会撞上 `manage`。
 *
 * 二级栏是动态的，所以承载页只有一条通配路由；pageKey 对不上时由 EmbedPage
 * 自己渲染「无权限或页面不存在」。
 */
const DataPortalRoutes: React.FC = () => {
    return (
        <Routes>
            <Route path="/" element={<AuthGuard><DataPortalLayout /></AuthGuard>}>
                <Route path="manage" element={<DataPortalManagePage />} />
                <Route path=":pageKey" element={<EmbedPage />} />
            </Route>
        </Routes>
    );
};

export default DataPortalRoutes;
